import { useState, useCallback } from 'react';

const useTouchInteraction = (onTap, isMobile = false) => {
  const [isActive, setIsActive] = useState(false);
  const [touchStart, setTouchStart] = useState({ x: 0, y: 0, time: 0 });
  const [isTouchMoved, setIsTouchMoved] = useState(false);

  const handleTouchStart = useCallback((e) => {
    const touch = e.touches[0];
    setTouchStart({
      x: touch.clientX,
      y: touch.clientY,
      time: Date.now()
    });
    setIsTouchMoved(false);
    setIsActive(true);
  }, []);

  const handleTouchMove = useCallback((e) => {
    if (!touchStart.x || !touchStart.y) return;
    
    const touch = e.touches[0];
    const moveX = Math.abs(touch.clientX - touchStart.x);
    const moveY = Math.abs(touch.clientY - touchStart.y);

    // If moved more than 10px in any direction, consider it a scroll
    if (moveX > 10 || moveY > 10) {
      setIsTouchMoved(true);
      setIsActive(false);
    }
  }, [touchStart]);

  const handleTouchEnd = useCallback((e) => {
    const touchDuration = Date.now() - touchStart.time;
    
    // Only trigger tap if:
    // 1. Touch duration is less than 200ms (quick tap)
    // 2. Haven't moved significantly (not scrolling)
    // 3. On mobile device
    if (!isTouchMoved && touchDuration < 200 && isMobile) {
      e.preventDefault();
      e.stopPropagation();
      onTap?.(e);
    }
    
    setIsActive(false);
    setTouchStart({ x: 0, y: 0, time: 0 });
  }, [isTouchMoved, touchStart.time, isMobile, onTap]);

  const handleClick = useCallback((e) => {
    if (!isMobile) {
      e.preventDefault();
      e.stopPropagation();
      onTap?.(e);
    }
  }, [isMobile, onTap]);

  return {
    isActive,
    isTouchMoved,
    handlers: {
      onClick: handleClick,
      onTouchStart: handleTouchStart,
      onTouchMove: handleTouchMove,
      onTouchEnd: handleTouchEnd
    },
    touchStates: {
      isActive,
      isTouchMoved
    }
  };
};

export default useTouchInteraction; 